export const FILTER_TYPE_TILL = "till";
export const FILTER_TYPE_IS = "is";
export const FILTER_TYPE_IS_NOT = "is not";
export const FILTER_TYPE_IS_BETWEEN = "is-between";
export const FILTER_TYPE_ONLY = "only";
